import { LLMProvider, LLMProviderInfo } from '../types/llm'

export const LLM_PROVIDERS: Record<LLMProvider, LLMProviderInfo> = {
  [LLMProvider.OpenAI]: {
    id: LLMProvider.OpenAI,
    name: 'OpenAI',
    models: ['gpt-4-turbo', 'gpt-4', 'gpt-3.5-turbo', 'gpt-3.5-turbo-16k'],
    defaultModel: 'gpt-4-turbo',
    baseUrl: 'https://api.openai.com/v1',
    requiresApiKey: true,
    description: 'OpenAI GPT models including GPT-4 and GPT-3.5'
  },
  [LLMProvider.Anthropic]: {
    id: LLMProvider.Anthropic,
    name: 'Anthropic',
    models: ['claude-3-opus-20240229', 'claude-3-sonnet-20240229', 'claude-3-haiku-20240307'],
    defaultModel: 'claude-3-sonnet-20240229',
    baseUrl: 'https://api.anthropic.com/v1',
    requiresApiKey: true,
    description: 'Anthropic Claude models including Opus, Sonnet, and Haiku'
  },
  [LLMProvider.Google]: {
    id: LLMProvider.Google,
    name: 'Google Gemini',
    models: ['gemini-pro', 'gemini-pro-vision'],
    defaultModel: 'gemini-pro',
    baseUrl: 'https://generativelanguage.googleapis.com/v1beta',
    requiresApiKey: true,
    description: 'Google Gemini models for text and multimodal tasks'
  },
  [LLMProvider.Mistral]: {
    id: LLMProvider.Mistral,
    name: 'Mistral',
    models: ['mistral-large-latest', 'mistral-medium-latest', 'mistral-small-latest', 'mistral-tiny'],
    defaultModel: 'mistral-small-latest',
    baseUrl: 'https://api.mistral.ai/v1',
    requiresApiKey: true,
    description: 'Mistral AI models optimized for efficiency'
  },
  [LLMProvider.Cohere]: {
    id: LLMProvider.Cohere,
    name: 'Cohere',
    models: ['command', 'command-light', 'command-nightly'],
    defaultModel: 'command',
    baseUrl: 'https://api.cohere.ai/v1',
    requiresApiKey: true,
    description: 'Cohere models for generation and understanding'
  },
  [LLMProvider.Custom]: {
    id: LLMProvider.Custom,
    name: 'Custom Provider',
    models: [],
    defaultModel: '',
    baseUrl: '',
    requiresApiKey: true,
    description: 'Configure a custom LLM provider endpoint'
  }
}

export const getProviderInfo = (provider: LLMProvider): LLMProviderInfo => {
  return LLM_PROVIDERS[provider]
}

export const getAllProviders = (): LLMProviderInfo[] => {
  return Object.values(LLM_PROVIDERS)
}
